import { BadgeOption } from 'src/types';
import { ICON_MAP } from 'src/utils/constants';
import { billingAttemptsMessages } from 'src/features/billingAttempts/utils/messages';
import { BILLING_ATTEMPT_ERROR_CODE, BILLING_ATTEMPT_STATUS } from 'src/features/billingAttempts/utils/types';

export const BILLING_ATTEMPT_STATUS_BADGE_OPTIONS: Record<BILLING_ATTEMPT_STATUS, BadgeOption> = {
    [BILLING_ATTEMPT_STATUS.SUCCEEDED]: {
        label: billingAttemptsMessages.succeeded,
        theme: 'green',
        icon: ICON_MAP.CHECK,
    },
    [BILLING_ATTEMPT_STATUS.FAILED]: {
        label: billingAttemptsMessages.failed,
        theme: 'red',
        icon: ICON_MAP.X_MARK,
    },
    [BILLING_ATTEMPT_STATUS.SKIPPED]: {
        label: billingAttemptsMessages.skipped,
        theme: 'gray',
        icon: ICON_MAP.MINUS_CIRCLE,
    },
};

/** Operator-facing sentence per error code, so the table never shows a raw slug. */
export const ERROR_CODE_MAP: Record<BILLING_ATTEMPT_ERROR_CODE, { id: string; defaultMessage: string }> = {
    [BILLING_ATTEMPT_ERROR_CODE.NO_BILLING_POLICY]: billingAttemptsMessages.noBillingPolicy,
    [BILLING_ATTEMPT_ERROR_CODE.NO_PRICING_POLICY]: billingAttemptsMessages.noPricingPolicy,
    [BILLING_ATTEMPT_ERROR_CODE.ALREADY_CHARGED]: billingAttemptsMessages.alreadyCharged,
    [BILLING_ATTEMPT_ERROR_CODE.NO_BILLING_ENTITY]: billingAttemptsMessages.noBillingEntity,
    [BILLING_ATTEMPT_ERROR_CODE.NO_ACCOUNTING_RANGE]: billingAttemptsMessages.noAccountingRange,
    [BILLING_ATTEMPT_ERROR_CODE.NO_ACCOUNTING_HEADING]: billingAttemptsMessages.noAccountingHeading,
    [BILLING_ATTEMPT_ERROR_CODE.NO_UNIT]: billingAttemptsMessages.noUnit,
    [BILLING_ATTEMPT_ERROR_CODE.NO_TAX_REASON]: billingAttemptsMessages.noTaxReason,
    [BILLING_ATTEMPT_ERROR_CODE.NEGATIVE_DOCUMENT_TOTAL]: billingAttemptsMessages.negativeDocumentTotal,
    [BILLING_ATTEMPT_ERROR_CODE.UNEXPECTED_ERROR]: billingAttemptsMessages.unexpectedError,
};

/** The error_code filter is a multi-select, which sources its options from badgeOptions. */
export const ERROR_CODE_BADGE_OPTIONS: Record<BILLING_ATTEMPT_ERROR_CODE, BadgeOption> = Object.fromEntries(
    Object.entries(ERROR_CODE_MAP).map(([code, label]) => [code, { label, theme: 'gray' }]),
) as Record<BILLING_ATTEMPT_ERROR_CODE, BadgeOption>;
